'use client';

import { StatusIcon } from './StatusIcon';

interface AvailabilityStatusIconProps {
  ok: boolean | null;
  compact?: boolean;
  messages?: {
    ok?: string;
    notOk?: string;
  };
}

const DEFAULT_MESSAGES = {
  ok: 'El horario del partido está dentro de la disponibilidad indicada por el equipo.',
  notOk: 'El horario del partido está fuera de la disponibilidad indicada por el equipo.',
};

export function AvailabilityStatusIcon({
  ok,
  messages,
}: AvailabilityStatusIconProps) {
  if (ok === null) return null;

  const okMessage = messages?.ok ?? DEFAULT_MESSAGES.ok;
  const notOkMessage = messages?.notOk ?? DEFAULT_MESSAGES.notOk;

  return ok ? (
    <StatusIcon
      variant="success"
      ariaLabel="Horario dentro de disponibilidad"
      message={okMessage}
    />
  ) : (
    <StatusIcon
      variant="warning"
      ariaLabel="Horario fuera de disponibilidad"
      message={notOkMessage}
    />
  );
}

